<!-- <select [formControl]="formControl">
  <option [ngValue]="null">Select a Supplier...</option>
  <option *ngFor="let item of suppliers$ | async" [ngValue]="item.code">
    <h3>{{ item.code }} - {{ item.name }}</h3>
  </option>
</select> -->

<div class="supplier-container">
  <ng-container *ngIf="selectedSupplier !== null; else NoSupplier">
    {{ selectedSupplier }}
  </ng-container>
  <ng-template #NoSupplier> No Supplier Selected </ng-template>
  <button
    *ngIf="selectedSupplier === null"
    class="button-ghost"
    (click)="selectDialog()"
  >
    Select Supplier
  </button>
</div>
